import React, { useEffect, useMemo, useState } from 'react';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import moment from 'moment';
import { Table } from '@components';
import { useModal } from 'mui-modal-provider';
const CorePagamentosListView = ({ $state, UIService, CorePagamentoService }) => {
    const loadParams = () => {
        const sortBy = $state.params.sortBy;
        if (sortBy == undefined) {
            return [];
        }
        const o = [];
        sortBy.forEach(r => {
            const s = r.split(':');
            o.push({ id: s[0], desc: s[1] == 'DESC' });
        });
        return o;
    };
    const { showModal } = useModal();
    const [data, setData] = useState();
    const [loading, setLoading] = useState(true);
    const [formasPagamento, setFormasPagamento] = useState([]);
    const [departamentos, setDepartamentos] = useState([]);
    const [refetching, setRefetching] = useState(false);
    const [options, setOptions] = useState({
        filter: [],
        sort: []
    });
    const [pagination, setPagination] = useState({
        pageIndex: $state.params.page - 1 || 0,
        pageSize: $state.params.limit || 20
    });
    const [filter, setFilter] = useState([]);
    const [sort, setSort] = useState(() => loadParams());
    const goTo = (row) => {
        try {
            if (!row.processo)
                return undefined;
            const valor = JSON.parse(row.processo);
            switch (row.departamentoId) {
                case 2:
                    return $state.href(`app.formacao.cursos.edicao.details`, { id: valor.cursoId, ed: valor.edicaoId }, { absolute: true });
                default:
                    return undefined;
            }
        }
        catch (e) {
            console.log(e);
            return undefined;
        }
    };
    const columns = useMemo(() => [
        {
            accessorKey: 'id',
            header: '#',
            size: 100,
            Cell: ({ renderedCellValue, row }) => 
            //<Link underline='none' color='default' sx={{ fontWeight: 'bold' }} target={'_blank'} href={$state.href('app.pagamentos.details', { id: row.original.id }, { absolute: true })}>
            renderedCellValue
            //</Link>
        },
        {
            accessorKey: 'departamentoId',
            exportKey: 'Departamento.designacao',
            header: 'Departamento',
            filterSelectOptions: departamentos.map(r => {
                return {
                    label: r.designacao,
                    value: r.id
                };
            }),
            size: 300,
            Cell: ({ row }) => row.original?.Departamento?.designacao
        },
        {
            accessorKey: 'tipo',
            header: 'Tipo',
            size: 70,
            Cell: ({ renderedCellValue }) => <Typography>{renderedCellValue || 'N/D'}</Typography>
        },
        {
            accessorKey: 'numeroProcesso',
            header: 'Nº Processo',
            size: 100,
            Cell: ({ renderedCellValue, row }) => {
                const link = goTo(row.original);
                return link ? (<Link underline='none' color='default' sx={{ fontWeight: 'bold' }} target={'_blank'} href={link}>
              {renderedCellValue}
            </Link>) : (renderedCellValue);
            }
        },
        {
            accessorKey: 'url',
            header: 'Site Pagamento',
            size: 100,
            Cell: ({ renderedCellValue, row }) => renderedCellValue ? (<Link underline='none' color='default' target={'_blank'} href={renderedCellValue}>
              {renderedCellValue}
            </Link>) : ('N/D')
        },
        {
            accessorKey: 'referencia',
            header: 'Referência',
            size: 100,
            Cell: ({ renderedCellValue }) => <Typography>{renderedCellValue || 'N/D'}</Typography>
        },
        {
            accessorKey: 'valor',
            header: 'Valor (€)',
            size: 70,
            Cell: ({ renderedCellValue }) => <Typography>{renderedCellValue ? new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }).format(renderedCellValue) : 'N/D'}</Typography>
        },
        {
            accessorKey: 'observacoes',
            header: 'Observações',
            size: 200,
            Cell: ({ renderedCellValue }) => <Typography>{renderedCellValue || 'N/D'}</Typography>
        },
        {
            accessorKey: 'pago',
            header: 'Pago?',
            size: 100,
            Cell: ({ renderedCellValue }) => <Typography>{renderedCellValue ? 'Sim' : 'Não'}</Typography>
        },
        {
            accessorKey: 'pagamentoData',
            header: 'Data de Pagamento',
            size: 150,
            Cell: ({ renderedCellValue, row }) => (row.original.pagamentoData && moment(row.original.pagamentoData).isValid() ? moment(row.original.pagamentoData).format('DD/MM/YYYY HH:mm') : 'N/D')
        },
        {
            accessorKey: 'formaPagamentoId',
            header: 'Forma de Pagamento',
            filterSelectOptions: formasPagamento.map(r => {
                return {
                    label: r.designacao,
                    value: r.id
                };
            }),
            size: 300,
            Cell: ({ row }) => row.original?.FormaPagamento?.designacao
        },
        {
            accessorKey: 'ultimaAlteracao',
            header: 'Última Alteração',
            size: 150,
            Cell: ({ renderedCellValue, row }) => (row.original.ultimaAlteracao && moment(row.original.ultimaAlteracao).isValid() ? moment(row.original.ultimaAlteracao).format('DD/MM/YYYY HH:mm') : 'N/D')
        }
    ], [departamentos, formasPagamento]);
    const getType = (type) => {
        switch (type) {
            case 'contains':
                return '$ilike';
            case 'startsWith':
                return '$sw';
            case 'notEquals':
                return '$not';
            case 'empty':
                return '$null';
            case 'notEmpty':
                return '$notNull';
            case 'greaterThan':
                return '$gt';
            case 'greaterThanOrEqualTo':
                return '$gte';
            case 'lessThan':
                return '$lt';
            case 'lessThanOrEqualTo':
                return '$lte';
            default:
                return '$eq';
        }
    };
    const initialFetch = async () => {
        if (loading) {
            setLoading(false);
            const opt = await CorePagamentoService.options();
            setOptions(opt);
            // Estado
            const rDepartamentos = await CorePagamentoService.getDepartamentos();
            setDepartamentos(rDepartamentos);
            const rFormasPagamento = await CorePagamentoService.getFormasPagamento();
            setFormasPagamento(rFormasPagamento);
        }
    };
    const fetchData = async () => {
        try {
            let filters = {};
            filter.forEach(r => {
                filters[r.id] = `${getType(r.type)}:${r.value}`;
            });
            let sorter = [];
            sort.forEach(r => {
                sorter.push(`${r.id}:${r.desc ? 'DESC' : 'ASC'}`);
            });
            const aux = await CorePagamentoService.table({
                limit: pagination.pageSize,
                page: pagination.pageIndex + 1,
                filter: filters,
                sortBy: sorter
            });
            $state.go($state.current.name, {
                limit: pagination.pageSize,
                page: pagination.pageIndex + 1,
                sortBy: sorter,
                filter: Object.keys(filter).length > 0 ? JSON.stringify(filters) : undefined
            }, {
                notify: false,
                reload: false,
                location: 'replace',
                inherit: true
            });
            // Update URL
            setData(aux);
        }
        catch (e) {
            console.log(e);
        }
        setRefetching(false);
    };
    useEffect(() => {
        initialFetch();
        if (!refetching) {
            setRefetching(true);
            fetchData();
        }
    }, [pagination, filter, sort]);
    return (<Box>
      <Box sx={{ mt: 2, mb: 2 }}>
        <Breadcrumbs aria-label='breadcrumb'>
          <Link underline='none' color='inherit'>
            Pagamentos
          </Link>
        </Breadcrumbs>
      </Box>

      <Box>
        <Table storageKey={$state.current.name} data={data} columns={columns} initial={{
            sort: sort,
            filter: filter
        }} isLoading={refetching} options={options} onPaginate={setPagination} onFilter={setFilter} onSort={setSort}/>
      </Box>
    </Box>);
};
export default CorePagamentosListView;
